import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'checkprivelleges',
})
export class PrivilegePipe implements PipeTransform {
  constructor() {}
  transform(array: any, key: string): any {
    if (array == undefined || array == null) {
      return true
    }
    let val = array[0][key]

    if (val == 'YES' || val == 'TRUE' || val == true) {
      return true
    } else {
      return false
    }
  }
}
